import React, {Component} from 'react';
import { connect } from 'react-redux';
import HeaderCountdown from "./HeaderCountdown";
import { Link } from 'react-router-dom';
import history from '../../history';
/**
 * Import assets
 */
import GLXLBadge from '../../assets/img/icons/begeleider.svg';

import apiCall from '../apiCall'
import ContentContainer from './ContentContainer';
import PopUp from './PopUp';
import ScoreRow from './ScoreRow';
import { __ } from 'i18n-for-browser';
import actions from "../../actions";
import config from '../../config';
import tabInfo from '../../helpers/tabInfo';

const { logout } = actions.user;


class TopBar extends Component {
  static defaultProps = {
    desktop: false,
  };

  constructor(props) {
    super(props);
    this.state = {
      expanded: false,
      schoolRank: '-',
      schoolClassRank: '-',
      totalPoints: '-',
      fetchedRankings: false,
    };
    this.logout = this.logout.bind(this);
    this.socketEventsAdded = false;
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    // Fetch latest ranking state everytime we open the dropdown
    if (!prevState.expanded && this.state.expanded) {
      this.fetchRankings();
    }
  }

  componentWillReceiveProps({ user }) {
    if (!this.state.fetchedRankings && user.loggedIn) {
      this.fetchRankings();
    }
    if (!this.socketEventsAdded && window.socket && window.socket.connected) {
      window.socket.on('finishedSimulationStep', this.fetchRankings);
      window.socket.on('activate', this.fetchRankings);
      this.socketEventsAdded = true;
    }
  }

  fetchRankings = async () => {
    return apiCall('/group/myRank', null, 'GET')
      .then(({ schoolClassRank, schoolRank, totalPoints }) => {
        this.setState({
          schoolClassRank,
          schoolRank,
          totalPoints,
          fetchedRankings: true,
        });
      });
  };

  /**
   * Render badge
   */
  renderBadge = () => {
    const { group, user } = this.props;
    let src = GLXLBadge;
    if (['groupleader', 'groupmember'].includes(user.role)) {
      src = `${config.apiUrl}${group.GroupTheme.badge}`;
      if (sessionStorage.getItem('governAsClassleader') === 'true') {
        tabInfo.setFavicon(`${window.location.origin}/logo-small.png`);
      }
    }
    return (
      <img alt="badge" src={src}/>
    );
  };

  logout() {
    if (sessionStorage.getItem('token')) {
      sessionStorage.removeItem('token');
      window.close();
    } else {
      sessionStorage.clear();
      localStorage.clear();
      this.props.dispatch(logout());
    }
  };

  /**
   * Render title
   */
  renderTitle = () => {
    let title = '';
    const { group, schoolClass, user, project } = this.props;
    if (user.role === 'classleader') {
      return <p className="title">
        {__('sim_begeleider')} <span style={{ position: 'relative', top: '-1px' }}>|</span> <span style={{ position: 'relative', top: '-1px', fontSize: '15px', textTransform: 'initial', fontWeight: 600 }}>{schoolClass.className}</span>
      </p>;
    }
    if (user.role === 'schoolcontact') title = project.nameSchoolPlace;

    if (['groupleader', 'groupmember'].includes(user.role)) {
      title = group.name;
      if (sessionStorage.getItem('governAsClassleader') === 'true') {
        tabInfo.setWindowTitle(__(group.GroupTheme.name));
      }
    }
    return (
      <p className={'title'}>{title}</p>
    );
  };

  /**
   * Render score container arrow (dropdown)
   */
  renderDropDownArrow = () => {
    // if (!['groupmember', 'groupleader'].includes(this.props.user.role)) return null;
    return (
      <span
        className={'arrow-button'}
      />
    );
  };

  toggleConfirmLogout = (ev) => {
    if (!ev) return;
    ev.preventDefault();
    let parent = ev.target.parentElement;

    let closeButton = false;

    while(parent) {
      if (parent.classList.contains('close-button')) {
        closeButton = true;
      }

      if (!closeButton) {
        if (parent.classList.contains('popup')) {
          return false;
        }
      }

      parent = parent.parentElement;
    }

    this.setState(prevState => ({
      confirmLogout: !prevState.confirmLogout,
    }));
  };

  /**
   * Render score container (dropdown)
   */
  renderScoreContainerWrapper = () => {
    const isPortalHome = (window.location.pathname === '/portal/group');
    if (!this.props.group || !this.props.group.loaded) return null;
    return (
      <div className={'score-container-wrapper'}>
        <ContentContainer>
          {(this.props.user.role && !this.props.user.role.startsWith('group') ? '' :
            <div className={'score-container'}>
              {this.props.project.EducationProject.nameShort === 'GLXL' ? (
                this.props.gameState.hideScores ? (
                  <p className={'disabled-scores'}>{__('sim_tussenstand_uitgeschakeld')}</p>
                ) : (
                  <div>
                    <ScoreRow
                      text={__('sim_puntentotaal')}
                      score={this.state.totalPoints || 0}
                    />
                    <ScoreRow
                      text={__('sim_ranglijst_school')}
                      score={this.state.schoolRank}
                    />
                    <ScoreRow
                      text={__('sim_ranglijst_klas')}
                      score={this.state.schoolClassRank}
                    />
                  </div>
                )
              ) : null}
            </div>
            )}
          <div className={'action-buttons'}>
            <Link to="/portal" onClick={() => {
              if (this.props.gameState.history) {
                window.sessionStorage.removeItem('history');
              }
              this.setState({ expanded: (!this.state.expanded) });
              this.props.dispatch(actions.feedback.setRound(this.props.feedback.all.length - 1));
            }} className={`button button-smallPadding ${(isPortalHome ? ' disabled' : '')}`}>
              <span>{__('sim_ga_naar_startscherm')}</span>
            </Link>
            <a href="" className="button" onClick={this.toggleConfirmLogout}>
              <span>{__('sim_uitloggen')}</span>
            </a>
          </div>
        </ContentContainer>
      </div>
    );
  };

  render() {
    const { desktop } = this.props;
    const inGame = !(history.location.pathname.indexOf("portal") > -1);
    return (
      <div className={`topbar-container${this.state.expanded ? ' expanded' : ''}${this.props.user.role === 'schoolcontact' ? ' tight' : ''}${desktop ? ' desktop-topbar' : ''}${inGame ? ' topbar--ingame' : ''}`}>
        <div className="background-overlay" onClick={() => { this.setState({ expanded: (!this.state.expanded) })}}/>
        <nav className="topbar">
          <div onClick={() => { this.setState({ expanded: (!this.state.expanded) })}}>
            {this.renderBadge()}
            {this.renderTitle()}
            {this.renderDropDownArrow()}
          </div>
          {(this.props.user.role === 'schoolcontact' ? '' :
            <HeaderCountdown
              role={this.props.user.role}/>
          )}

        </nav>
        {this.renderScoreContainerWrapper()}
        {
          this.state.confirmLogout
          ? <PopUp
              title={__('sim_uitloggen')}
              description={__('sim_bevestig_uitloggen')}
              showPopUp={true}
              closePopUpCross={true}
              zIndex={9999}
              customButton={{
                text: __('sim_uitloggen'),
                action: () => this.logout(),
              }}
              closePopUpClick={this.toggleConfirmLogout}
            />
          : null
        }
      </div>
    );
  }
}

export default connect(state => ({
  project: state.project,
  schoolClass: state.schoolClass,
  user: state.user,
  group: state.group,
  gameState: state.gameState,
  feedback: state.feedback,
}))(TopBar);



// WEBPACK FOOTER //
// ./src/components/elements/TopBar.js